<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-top">
          <!-- 品牌区域 -->
          <div class="footer-brand">
            <router-link to="/" class="brand-link">
              <img :src="logo" alt="比优集团" class="footer-logo">
              <div class="brand-text">
<!--                <img :src="logoF" alt="比优集团" class="footer-logoF">-->
              </div>
            </router-link>
          </div>

          <!-- 导航区域 -->
          <div class="footer-nav">
            <!-- 关于我们 -->
            <div class="nav-col">
              <h4 class="nav-title">{{ t('menu.about') }}</h4>
              <router-link to="/about" class="nav-link">{{ t('menu.about') }}</router-link>
              <router-link to="/about/executives" class="nav-link">{{ t('menu.executives') }}</router-link>
              <router-link to="/about/group_events" class="nav-link">{{ t('menu.group_events') }}</router-link>
              <router-link to="/about/honors" class="nav-link">{{ t('menu.honors') }}</router-link>
              <router-link to="/about/video" class="nav-link">{{ t('menu.company_video') }}</router-link>
            </div>

            <!-- 主营业务 -->
            <div class="nav-col">
              <h4 class="nav-title">{{ t('menu.main_business') }}</h4>
              <router-link to="/business/mining" class="nav-link">{{ t('menu.mining') }}</router-link>
              <router-link to="/business/mine-construction" class="nav-link">{{ t('menu.mine-construction') }}</router-link>
              <router-link to="/business/explosives" class="nav-link">{{ t('menu.explosives') }}</router-link>
              <router-link to="/business/overseas" class="nav-link">{{ t('menu.overseas') }}</router-link>
              <router-link to="/business/technical" class="nav-link">{{ t('menu.technical') }}</router-link>
            </div>

            <!-- 新闻资讯 -->
            <div class="nav-col">
              <h4 class="nav-title">{{ t('menu.news') }}</h4>
              <router-link to="/news" class="nav-link">{{ t('menu.news') }}</router-link>
            </div>

            <!-- 投资者关系资讯 -->
            <div class="nav-col">
              <h4 class="nav-title">{{ t('menu.investors') }}</h4>
              <router-link to="/notice" class="nav-link">{{ t('index.announcements_reports') }}</router-link>
              <router-link to="/notice/esg" class="nav-link">{{ t('menu.esg_management') }}</router-link>
            </div>
            <!-- 联系我们 -->
            <div class="nav-col">
              <h4 class="nav-title">{{ t('menu.contact') }}</h4>
              <router-link to="/contact" class="nav-link">{{ t('menu.contact') }}</router-link>
            </div>
          </div>
        </div>

        <!-- 版权区域 -->
        <div class="footer-copyright">
          <div class="copyright-info">
            <p class="copyright-text">{{ t('footer.copyright') }}</p>
            <p class="company-info">{{ t('footer.company_info') }}</p>
          </div>
          <div class="footer-legal">
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import { ChatRound, Share } from '@element-plus/icons-vue';
import logo from '@/assets/img/logo.png';
import logoF from '@/assets/img/logoF.png';

const { t } = useI18n();
const route = useRoute();

// 社交媒体链接（可根据实际情况配置）
const socialLinks = ref({
  weChat: '',
  linkedIn: ''
});

// 当前年份
const currentYear = new Date().getFullYear();
</script>

<style scoped lang="scss">
// 引入比优集团VIS统一变量
@import '@/assets/css/common';

.footer {
  // 调整：深色背景（深灰+主色暗衍生色渐变），比原深棕更沉稳和谐
  background: linear-gradient(135deg, $gray-80 0%, $primary-dark-4 100%);
  color: $white;
  padding: 60px 0 20px;
  font-family: $font-base;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    // 调整：分割线用主色低透明度，强化品牌
    background: linear-gradient(90deg, transparent, rgba($primary-color, 0.3), transparent);
  }
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  position: relative;
  z-index: 1;
}

.footer-content {
  display: flex;
  flex-direction: column;
  gap: 50px;
}

.footer-top {
  display: grid;
  grid-template-columns: 1fr 4fr;
  gap: 60px;

  @media (max-width: 992px) {
    grid-template-columns: 1fr;
    gap: 40px;
  }
}

// 品牌区域
.footer-brand {
  .brand-link {
    display: flex;
    align-items: center;
    gap: 16px;
    text-decoration: none;
    color: inherit;
    margin-bottom: 24px;

    @media (max-width: 768px) {
      flex-direction: column;
      text-align: center;
      gap: 12px;
    }
  }

  .footer-logo {
    height: 50px;
    width: auto;

    @media (max-width: 768px) {
      height: 40px;
    }
  }
  .footer-logoF {
    height: 40px;
    width: auto;

    @media (max-width: 768px) {
      height: 32px;
    }
  }
  .brand-text {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .brand-title {
    font-family: $font-serif;
    font-size: 1.5rem;
    font-weight: 700;
    color: $white;
    margin: 0;
    line-height: 1.2;

    @media (max-width: 768px) {
      font-size: 1.25rem;
    }
  }

  .brand-slogan {
    font-size: 0.875rem;
    // 调整：标语用主色浅衍生色，贴合深色背景
    color: $primary-light-3;
    margin: 0;
    line-height: 1.4;
  }

  .social-icons {
    display: flex;
    gap: 12px;
    margin-top: 16px;

    .social-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 36px;
      height: 36px;
      // 调整：社交图标背景用主色低透明度
      background: rgba($primary-color, 0.2);
      border-radius: 50%;
      color: $white;
      text-decoration: none;
      transition: all 0.3s ease;

      &:hover {
        // 保留：hover时用主色背景
        background: $primary-color;
        transform: translateY(-2px);
      }

      :deep(.el-icon) {
        font-size: 1.125rem;
      }
    }
  }
}

// 导航区域
.footer-nav {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 30px;

  @media (max-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 30px 20px;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
}

.nav-col {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.nav-title {
  font-size: 1.125rem;
  font-weight: 600;
  color: $white;
  margin: 0;
  padding-bottom: 8px;
  // 调整：导航标题下划线用主色低透明度
  border-bottom: 1px solid rgba($primary-color, 0.2);
}

.nav-link {
  // 调整：导航链接用主色浅衍生色，贴合深色背景
  color: $primary-light-3;
  text-decoration: none;
  font-size: 0.9375rem;
  transition: all 0.3s ease;
  position: relative;
  padding-left: 0;
  display: inline-block;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 6px;
    height: 6px;
    // 保留：圆点用主色，强化品牌
    background: $primary-color;
    border-radius: 50%;
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &:hover,
  &.router-link-active {
    color: $white;
    padding-left: 12px;

    &::before {
      opacity: 1;
    }
  }

  &.router-link-active {
    font-weight: 500;
  }
}

// 版权区域
.footer-copyright {
  // 调整：版权区上边框用主色低透明度
  border-top: 1px solid rgba($primary-color, 0.2);
  padding-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
    gap: 16px;
  }
}

.copyright-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.copyright-text {
  font-size: 0.875rem;
  // 调整：版权文字用主色浅衍生色
  color: $primary-light-4;
  margin: 0;
}

.company-info {
  font-size: 0.75rem;
  // 调整：公司信息用主色浅衍生色（更浅）
  color: $primary-light-6;
  margin: 0;
  opacity: 0.8;
}

.footer-legal {
  display: flex;
  align-items: center;
  gap: 16px;

  @media (max-width: 768px) {
    justify-content: center;
  }
}

.legal-link {
  // 调整：法律链接用主色浅衍生色
  color: $primary-light-4;
  text-decoration: none;
  font-size: 0.875rem;
  transition: color 0.3s ease;

  &:hover {
    color: $white;
  }
}

.divider {
  // 调整：分隔符用主色浅衍生色
  color: $primary-light-6;
  opacity: 0.5;
}

// 响应式调整
@media (max-width: 1200px) {
  .container {
    padding: 0 30px;
  }
}

@media (max-width: 992px) {
  .footer {
    padding: 50px 0 20px;
  }

  .footer-content {
    gap: 40px;
  }

  .footer-top {
    gap: 40px;
  }

  .footer-nav {
    gap: 20px;
  }
}

@media (max-width: 768px) {
  .container {
    padding: 0 20px;
  }

  .footer {
    padding: 40px 0 20px;
  }

  .footer-content {
    gap: 30px;
  }

  .footer-nav {
    gap: 30px 15px;
  }

  .nav-title {
    font-size: 1rem;
  }

  .nav-link {
    font-size: 0.875rem;
  }
}

@media (max-width: 480px) {
  .container {
    padding: 0 16px;
  }

  .footer {
    padding: 30px 0 16px;
  }
}
</style>